import React from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { COURSE_URL } from "../../constants";
import { apiDefine } from '../../api/web'
// import AXIOS from '../../api/axios';
import MemberPage from "../memberPage/MemberPage";
import AppPayPage from "../payPage/AppPayPage";
import WebPayPage from "../payPage/WebPayPage"; // pc、pad会员中心
import H5PayPage from "../payPage/H5PayPage"; // h5支付
import DownloadPage from "../customerPage/DownloadPage"; // 下载页

import Paylink from "../payPage/Paylink"; // 扫码支付页
import SharePage from "../sharePage/SharePage"; // 作业分享页
import SuccessPage from "../payPage/SuccessPage"; // 支付成功页
import RulesPage from '../customerPage/RulesPage'; // 用户协议
import GuidePage from "../guidePage/GuidePage"; // 新手引导
import Privacy from "../privacyPage/privacyPage"; // 隐私协议

import HomeworkPage from "../homeworkNewPage/HomeworkPage"; // 作业主页
import CarriagePage from "../homeworkNewPage/CarriagePage"; // 作业冰淇淋车
import ArcheryPage from "../homeworkNewPage/ArcheryPage"; // 作业射箭
import CastlePage from "../homeworkNewPage/CastlePage"; // 作业烟花
import HomeworkResultPage from "../homeworkNewPage/HomeworkResultPage"; // 作业结果页

import CoursedetailPage from "../courseDetailPage/CourseDetailPage"; // 课程详情
import PhonicsDetaiPage from "../phonicsDetailPage/PhonicsDetaiPage"; // 课程详情
import MemberNewPage from "../memberNewPage/MemberNewPage"; // 会员中心页
import AddressPage from "../experimentOrderPage/AddressPage"; // nasa收货地址
import NASAPayPage from "../experimentOrderPage/NASAPayPage"; // nasa支付页
import DiscountCouponPage from '../experimentOrderPage/DiscountCouponPage'; // 选择优惠券页面
import LogisticsPage from "../experimentOrderPage/LogisticsPage"; // 物流详情页
import PaymentAgreement from "../paymentAgreement/paymentAgreement"; // 用户支付协议
import UniversePayPage from "../UniversePayPage/UniversePayPage";
import AchievementRulesPage from "../customerPage/achievementRules";
import PuDetaiPage from "../puDetailPage/puDetailPage";
import FeedbackPage from "../feedbackPage/feedbackPage";
import FeedbackDetailPage from "../feedbackPage/feedbackDetailPage";

import clientApi from "../../api/client";
import UA from "../../utils/ua";
import "./style.less";
import { myStorage } from "../../utils/tools";
import RulesPageBinguo from "../customerPage/RulesPageBinguo";
import PrivacyBinguoPage from "../privacyPage/privacyBinguoPage";
class RouteComponent extends React.Component {
  constructor(props) {
    super(props);
    myStorage.init();
    this.storage = myStorage;
    this.state = {};
  }

  componentWillMount(){
    let clientData = {
      token: '',
      device: ''
    };
    if(UA.ACClient){
      const { token, device } = JSON.parse(clientApi.getClientDataSync({ data: ["token", "device"] })) || {};
      clientData = { token }
      clientData.device = device || 'Android';
    }
    this.storage.setItem('panda_client_data', JSON.stringify(clientData));
  }

  componentDidMount(){

    apiDefine({apiName:'sendClientData',fn:function(res){
      if(res){
          const data = JSON.parse(res);
          window.myContext = {...window.myContext,...data};
      }
    }});

    // AXIOS.login({
    // 	data:{phone:'00100001111',smsCode:171204,channel:'MOBILE', debug:1}
    // },function(res,err){
	// 	if(err) console.log(err);
	// 	else{
	// 		window.token = res.accessToken; 
	// 	}
    // })
  }
  render() {
    return (
      <Switch>
        <Route path={`${COURSE_URL}/webpay`} component={WebPayPage} />
        <Route path={`${COURSE_URL}/apppay`} component={AppPayPage} />
        <Route path={`${COURSE_URL}/h5pay`} component={H5PayPage} />
        <Route path={`${COURSE_URL}/paylink`} component={Paylink} />
        <Route path={`${COURSE_URL}/share`} component={SharePage} />
        <Route path={`${COURSE_URL}/success`} component={SuccessPage} />
        <Route path={`${COURSE_URL}/customerrules`} component={RulesPage} />
        <Route path={`${COURSE_URL}/customerrules-binguo`} component={RulesPageBinguo} />
        <Route path={`${COURSE_URL}/achievementrules`} component={AchievementRulesPage} />
        <Route path={`${COURSE_URL}/download`} component={DownloadPage} />
        <Route path={`${COURSE_URL}/member`} component={MemberPage} />
        <Route path={`${COURSE_URL}/membernew`} component={MemberNewPage} />
        <Route path={`${COURSE_URL}/guide`} component={GuidePage} />
        <Route path={`${COURSE_URL}/privacy`} component={Privacy} />
        <Route path={`${COURSE_URL}/privacy-binguo`} component={PrivacyBinguoPage} />
        <Route path={`${COURSE_URL}/address`} component={AddressPage} />
        <Route path={`${COURSE_URL}/nasapay`} component={NASAPayPage} />
        <Route path={`${COURSE_URL}/phonicspay`} component={UniversePayPage} />
        <Route path={`${COURSE_URL}/universepay`} component={UniversePayPage} />
        <Route path={`${COURSE_URL}/discountcoupon`} component={DiscountCouponPage} />
        <Route path={`${COURSE_URL}/paymentAgreement`} component={PaymentAgreement} />
        <Route path={`${COURSE_URL}/logistics`} component={LogisticsPage} />
        <Route path={`${COURSE_URL}/nasadetail`} component={CoursedetailPage} />
        <Route path={`${COURSE_URL}/phonicsdetail`} component={PhonicsDetaiPage} />
        <Route path={`${COURSE_URL}/pudetail`} component={PuDetaiPage} />
        <Route path={`${COURSE_URL}/coursedetail`} component={CoursedetailPage} />
        {/* <Route path={`${COURSE_URL}/homeworkresult`} component={HomeworkResultPage} /> */}
        <Route path={`${COURSE_URL}/homework/index`} component={HomeworkPage} />
        <Route path={`${COURSE_URL}/homework/result`} component={HomeworkResultPage} />
        <Redirect
            exact
            from={`${COURSE_URL}/homework`}
            to={{
              pathname: `${COURSE_URL}/homework/index`,
              search: window.location.search
            }}
        />
        <Route path={`${COURSE_URL}/homework/castle/:index`} component={CastlePage} />
        {/* <Route path={`${COURSE_URL}/homework/castle/:index`} component={Homework} /> */}
        <Route path={`${COURSE_URL}/homework/archery/:index`} component={ArcheryPage} />
        <Route path={`${COURSE_URL}/homework/carriage/:index`} component={CarriagePage} />
        <Route path={`${COURSE_URL}/feedback/:id`} component={FeedbackDetailPage} />
        <Route path={`${COURSE_URL}/feedback`} component={FeedbackPage} />
      </Switch>
    );
  }
}

export default withRouter(RouteComponent);



// WEBPACK FOOTER //
// ./src/components/RouteComponent/main.js